import Snnit from "./IDCard/Snnit";
import Voters from "./IDCard/Voters";
import Drivers from "./IDCard/Drivers";
import Passport from "./IDCard/Passport";

export default Object.assign({}, { Snnit, Voters, Drivers, Passport });
